/**
 * Detail synopsis arrows component.
 */
import ArrowLeftIcon from '@components/atoms/icons/arrowLeft';
import ArrowRightIcon from '@components/atoms/icons/arrowRight';
import DetailArrowLeftContainer from '@components/atoms/container/detailSynopsisArrowLeftContainer';
import DetailArrowRightContainer from '@components/atoms/container/detailSynopsisArrowRightContainer';
import DetailSynopsisArrowContainer from '@components/atoms/container/detailSynopsisArrowContainer';

/**
 * Constants.
 *
 * @constant {number} ARROW_HEIGHT - Height of the arrows.
 * @constant {number} ARROW_WIDTH - Width of the arrows.
 */
const ARROW_HEIGHT = 40;
const ARROW_WIDTH = 24;

/**
 * Props for the DetailArrows component.
 */
interface Props {
  focused: boolean;
  display: {
    left: boolean;
    right: boolean;
  };
  navigate: {
    left: () => void;
    right: () => void;
  };
}

/**
 * Renders the detail synopsis arrows component.
 */
export default function DetailArrows({ display, focused, navigate }: Props) {
  return (
    <DetailSynopsisArrowContainer focused={focused}>
      {/* Left arrow  */}
      <DetailArrowLeftContainer
        id={'arrowLeft'}
        display={display.left}
        onClick={() => navigate.left()}
      >
        <ArrowLeftIcon width={ARROW_WIDTH} height={ARROW_HEIGHT} />
      </DetailArrowLeftContainer>
      {/* Right arrow  */}
      <DetailArrowRightContainer
        id={'arrowRight'}
        display={display.right}
        onClick={() => navigate.right()}
      >
        <ArrowRightIcon width={ARROW_WIDTH} height={ARROW_HEIGHT} />
      </DetailArrowRightContainer>
    </DetailSynopsisArrowContainer>
  );
}
